<template>
    <div>
        <button class="botao align-self-center" data-bs-toggle="modal" 
            @click="moment().isSameOrAfter(moment('30-12-2026','DD-MM-YYYY')) ? abrirTelaErro() :  ''"
            :data-bs-target="moment().isSameOrAfter(moment('30-12-2026','DD-MM-YYYY')) ? `` : '#Chamado' + tpChamado.id"
            :style="{ backgroundColor: tpChamado.cor, color: tpChamado.fonte, borderColor: tpChamado.borda }"
            :class="{ 'circuloDesabilitado': !tpChamado.ativo }">
            <img :class="'chamado' + tpChamado.id" :src="require(`@/../imagens/${tpChamado.id}-icone.png`)">
            {{ tpChamado.descricao }} 
        </button>

        <div class="modal fade" :id="'Chamado' + tpChamado.id" tabindex="-1" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="modal-title" id="exampleModalLabel">Confirmação</h2>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p class="pModal" v-if="state.resposta == false">Deseja chamar a {{ tpChamado.descricao }} ?</p>
                        <SubChamados v-for="tpChamListSub in state.tpChamadoListarSub" :key="tpChamListSub.id"
                            :tpChamado="tpChamado" :tpChamListSub="tpChamListSub" @realizarChamado="realizarChamado"
                            v-else-if="state.resposta == true" />
                    </div>
                    <div class="modal-footer" v-if="state.resposta == false">
                        <button id="btnCancelar" type="button" class="btn btn-secondary"
                            data-bs-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="realizarChamado(tpChamado)"
                            data-bs-dismiss="modal">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modalHenrique fade show" :id="`erro${tpChamado.id}`" tabindex="-1" aria-labelledby="" aria-modal="true"
            aria-hidden="true" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fs-3" id="staticBackdropLabel">{{ state.titulo }}</h5>
                    </div>
                    <div class="modal-body">
                        <p class="fs-4"> {{ state.textoErro }}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" @click="modalResult()"
                            data-bs-dismiss="modalHenrique">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="state.abrirTelaErro" class="modal-backdrop fade show" :id="`erroConexao`" tabindex="-1" aria-labelledby="" aria-modal="true" aria-hidden="true" role="dialog" />


        <div v-if="state.abrirTelaErro" class="modalErro fade show">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <p class="fs-4"> {{ state.erroProgramado == true ? 'O sistema expirou, entre em contato com o suporte' : 'Ocorreu um erro de conexão'}} </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" @click="fecharTelaErroConexao()">
                            Sair
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="state.temErro" class="modal-backdrop fade show" id="backdrop2" />
    </div>
</template>

<script setup>
import api from '@/api/api';
import SubChamados from '@/components/SubChamados.vue';
import TipoChamado from '@/model/TipoChamado';
import { onMounted, reactive, defineProps, defineEmits } from 'vue';
import roteador from '@/roteador/indexRoteador';
import ModalConfirmaAgape from './ModalConfirmaAgape.vue';
import moment from 'moment';

const props = defineProps(['tpChamado', 'chamadosAbertos', 'listarAbertos']);
const emits = defineEmits(['tpListar', 'tpSalvar']);

onMounted(async () => {
    listarSub();
    existeSub();
});

const state = reactive({
    tpChamadoListarSub: [],
    resposta: false,
    abrirTelaErro:false,
    erroProgramado:false,
    temErro: Boolean(),
    textoErro: String("Não é possível abrir dois chamados para Urgência ao mesmo tempo"),
    titulo: String("Aviso"),
});

async function listarSub() {
    await api.tipoChamadoListarSub(props.tpChamado.id)
        .then(resp => {
            resp.forEach(tpCh => {
                state.tpChamadoListarSub.push(new TipoChamado(tpCh.id, tpCh.descricao,
                    tpCh.ativo, tpCh.cor, tpCh.som, tpCh.fonte, tpCh.borda, tpCh.corIcone, tpCh.urgencia, tpCh.id_Principal));
            });
        })
        .catch(erro => {
            console.log(erro);
        });
}

function abrirTelaErro() {
    if(moment().isSameOrAfter(moment('30-12-2026','DD-MM-YYYY')))
        state.erroProgramado = true;
    state.abrirTelaErro = true;

}
function fecharTelaErroConexao() {
    state.abrirTelaErro = false;
}

async function existeSub() {
    await api.tipoChamadoExisteSub(props.tpChamado.id)
        .then(resp => {
            state.resposta = resp;
        })
        .catch(erro => {
            console.log(erro);
        });
}

async function realizarChamado(tpChamListSub) {
    let temUrgencia = false;

    props.chamadosAbertos.forEach((c, i) => {
        if (c.letraChamado == "U")
            temUrgencia = true;
    });

    if (temUrgencia == false || tpChamListSub.codigo != "U") {
        await api.realizarChamado(tpChamListSub.id, roteador.currentRoute.value.params.id)//.params.id)
            .catch(erro => {
                alert(`Parece que há um problema de conexão ${erro}`)
            });
        emits('tpListar', state.tpChamadoListarSub);
        props.listarAbertos();
    } else {
        state.temErro = true;
        ativarModalErro();
    }
}

function modalResult() {
    state.temErro = false;
    document.querySelector(`#erro${props.tpChamado.id}`).style = "display:none";
}

function ativarModalErro() {
    document.querySelector(`#erro${props.tpChamado.id}`).style = "display:block";
}

</script>

<style scoped>
.circulo {
    width: 125px;
    height: 125px;
    border-radius: 50%;
    overflow: hidden;
    float: center;
    margin-top: 15px;
    margin-bottom: 15px;
    cursor: pointer;
}

.modalHenrique {
    --bs-modal-zindex: 1055;
    --bs-modal-width: 500px;
    --bs-modal-padding: 1rem;
    --bs-modal-margin: 0.5rem;
    --bs-modal-color: ;
    --bs-modal-bg: #fff;
    --bs-modal-border-color: var(--bs-border-color-translucent);
    --bs-modal-border-width: 1px;
    --bs-modal-border-radius: 0.5rem;
    --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    --bs-modal-inner-border-radius: calc(0.5rem - 1px);
    --bs-modal-header-padding-x: 1rem;
    --bs-modal-header-padding-y: 1rem;
    --bs-modal-header-padding: 1rem 1rem;
    --bs-modal-header-border-color: var(--bs-border-color);
    --bs-modal-header-border-width: 1px;
    --bs-modal-title-line-height: 1.5;
    --bs-modal-footer-gap: 0.5rem;
    --bs-modal-footer-bg: ;
    --bs-modal-footer-border-color: var(--bs-border-color);
    --bs-modal-footer-border-width: 1px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--bs-modal-zindex);
    display: none;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}

.modalErro{
    --bs-modal-zindex: 1055;
    --bs-modal-width: 500px;
    --bs-modal-padding: 1rem;
    --bs-modal-margin: 0.5rem;
    --bs-modal-color: ;
    --bs-modal-bg: #fff;
    --bs-modal-border-color: var(--bs-border-color-translucent);
    --bs-modal-border-width: 1px;
    --bs-modal-border-radius: 0.5rem;
    --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
    --bs-modal-inner-border-radius: calc(0.5rem - 1px);
    --bs-modal-header-padding-x: 1rem;
    --bs-modal-header-padding-y: 1rem;
    --bs-modal-header-padding: 1rem 1rem;
    --bs-modal-header-border-color: var(--bs-border-color);
    --bs-modal-header-border-width: 1px;
    --bs-modal-title-line-height: 1.5;
    --bs-modal-footer-gap: 0.5rem;
    --bs-modal-footer-bg: ;
    --bs-modal-footer-border-color: var(--bs-border-color);
    --bs-modal-footer-border-width: 1px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--bs-modal-zindex);
    display: inherit;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}

.circuloDesabilitado {
    /* Ajustar o display pra ficar meio acizentado */
    display: none;
}

.circuloDesabilitado:hover {
    cursor: default;
}

.pModal {
    font-size: 20px;
}

.contadorDesabilitado {
    display: none;
}

.botao {
    border: 4px solid;
    font-weight: bold;
    text-transform: uppercase;
}

/*
img {
    width: 36px;
    height: 30px;
}
*/
.chamado1 {
    width: calc(var(--tamanho) * 3 * 1.1 * 1.5);
    height: calc(var(--tamanho) * 2.4 * 1.5);
}

.chamado2 {
    width: calc(var(--tamanho) * 2.4 * 1.5);
    height: calc(var(--tamanho) * 2.4 * 1.5);
}

.chamado3 {
    width: calc(var(--tamanho) * 3.0 * 1.5);
    height: calc(var(--tamanho) * 2.4 * 1.5);
}
</style>